// extracted by mini-css-extract-plugin
module.exports = {"link":"RelatedLinkCell_link__rf7_Z","text":"RelatedLinkCell_text__mQKv6","single":"RelatedLinkCell_single__4Snrn","icon":"RelatedLinkCell_icon__mrqQr"};